// Slice B2.4-D — cross-session peek telemetry row shape.

import type { ActivityDockAssistLevel } from "./assistLevelTypes.js";

/** How far back the dev-panel cross-session rollup looks. */
export const PEEK_TELEMETRY_WINDOW_DAYS = 30;

export type ActivityDockPeekTelemetryRow = {
  id: string;
  organization_id: string | null;
  user_id: string;
  reason_section_id: string;
  mode: string;
  bucket_id: string | null;
  assist_level: ActivityDockAssistLevel;
  client_ts: number;
  created_at: string;
};

export type ActivityDockPeekTelemetryInsert = {
  organizationId: string | null;
  userId: string;
  reasonSectionId: string;
  mode: string;
  bucketId: string | null;
  assistLevel: ActivityDockAssistLevel;
  clientTs: number;
};
